import React from 'react';
import { Grid } from '@mui/material';
import { SearchTextField } from './index';
import { useAuth } from '../../hooks/useAuth';
import { DEVELOPER_THEME } from '../../types/common';

interface DeveloperUserIdSearchProps {
  userIdSearchTerm: string;
  onUserIdSearchTermChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClearUserIdField: () => void;
}

const DeveloperUserIdSearch: React.FC<DeveloperUserIdSearchProps> = ({
  userIdSearchTerm,
  onUserIdSearchTermChange,
  onClearUserIdField
}) => {
  const { isDeveloper } = useAuth();

  // 開発者モードでない場合は何も表示しない
  if (!isDeveloper()) {
    return null;
  }

  return (
    <Grid item xs={12} md={3}>
      <SearchTextField
        label="User ID"
        value={userIdSearchTerm}
        onChange={onUserIdSearchTermChange}
        onClear={onClearUserIdField}
        placeholder="部分一致で検索 (開発者モード)"
        sx={{
          bgcolor: `${DEVELOPER_THEME.BACKGROUND_ALPHA}`,
          borderRadius: 1,
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
              borderColor: DEVELOPER_THEME.DARK,
            },
            '&:hover fieldset': {
              borderColor: DEVELOPER_THEME.BORDER,
            },
            '& fieldset': {
              borderColor: `${DEVELOPER_THEME.BORDER_LIGHT_ALPHA}`,
              borderStyle: 'dashed',
            }
          },
          '& .MuiInputLabel-root': {
            color: 'rgba(0, 0, 0, 0.6)',
            '&.Mui-focused': {
              color: DEVELOPER_THEME.DARK,
            }
          },
          '& .MuiInputBase-input': {
            '&::placeholder': {
              color: 'rgba(121, 85, 72, 0.5)',
              fontStyle: 'italic'
            }
          },
          '& .MuiIconButton-root': {
            color: DEVELOPER_THEME.DARK,
          }
        }}
      />
    </Grid>
  );
};

export default DeveloperUserIdSearch;